<script setup lang="ts">
import Icon from '~/components/global/Icon.vue'

const slots = useSlots()
</script>

<template>
  <div class="c-filter-trigger-content">
    <div class="c-filter-trigger-content__main">
      <small v-if="slots.label" class="c-filter-trigger-content__label">
        <slot name="label" />
      </small>

      <strong v-if="slots.value" class="c-filter-trigger-content__value">
        <slot name="value" />
      </strong>
    </div>

    <Icon class="c-filter-trigger-content__icon" name="chevron-down" />
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-filter-trigger-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 20px;
  min-width: 160px;
  min-height: 52px;

  @include breakpoint-down('xl') {
    padding: 6px 16px;
    min-width: 140px;
  }

  &__main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: var(--color-solid-grey-dark);
  }

  &__value {
    font-size: 16px;
    font-weight: 500;
    color: var(--color-primary);
  }

  &__icon {
    font-size: 12px;
    font-weight: 500;
    color: var(--color-primary);
  }
}
</style>
